var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_53181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519938 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM8.51053 18.3158H5.89264V9.88263H8.51053V18.3158ZM7.20001 8.73158C6.89872 8.73282 6.60383 8.64472 6.35261 8.4784C6.10138 8.31209 5.90511 8.07502 5.78859 7.79718C5.67207 7.51934 5.64053 7.21318 5.69797 6.91742C5.75541 6.62166 5.89925 6.34957 6.11129 6.13553C6.32334 5.9215 6.59408 5.77514 6.88929 5.71494C7.18451 5.65475 7.49094 5.68343 7.76986 5.79735C8.04878 5.91128 8.28766 6.10534 8.45631 6.355C8.62496 6.60466 8.71581 6.89872 8.71737 7.2C8.71822 7.604 8.55908 7.99191 8.27474 8.27891C7.9904 8.56591 7.604 8.72866 7.20001 8.73158ZM18.3158 18.3158H15.6995V14.2105C15.6995 13.2316 15.6805 11.9763 14.3384 11.9763C12.9963 11.9763 12.7595 13.0405 12.7595 14.1395V18.3158H10.1526V9.88263H12.6647V11.0321H12.7011C13.05 10.3689 13.9042 9.66947 15.1784 9.66947C17.8279 9.66947 18.3158 11.4158 18.3158 13.6832V18.3158Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_53181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7d55018e7ad91ba4099f2347690e376a.svg";
export { ForwardRef as ReactComponent };